module.exports = __webpack_public_path__ + "static/media/404@3x.e8d61b0e.png";